var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"template-detail-layout"},[_c('div',{staticClass:"template-detail-layout__heading"},[_vm._t("option-heading")],2),_c('div',{staticClass:"template-detail-layout__content"},[_vm._t("option-content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }